import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./en.json";
import esTranslation from "./es.json";
import eusTranslation from "./eus.json";
import deTranslation from "./de.json";
import moment from "moment";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: enTranslation,
    },
    eu: {
        translation: eusTranslation,
    },
    es: {
        translation: esTranslation,
    },
    de: {
        translation: deTranslation,
    },
};

const options = {
    order: ["cookie", "navigator"],
    lookupQuerystring: "lng",
    lookupQuerystring: "lng",
};

moment.locale("eu", {
    months: "Urtarrilak_Otsailak_Martxok_Apirilak_Maiatzak_Ekaineak_Uztailak_Abuztuak_Irailak_Urriak_Abenduak".split("_"),
    monthsShort: "Urt-ak._Ots-ak._Mar-ak._Api-ak._Mai-ak._Uzt-ak._Abu-ak._Ira-ak._Urr-ak._Aza-ak._Abe-ak.".split("_"),
    weekdays: "Igandea_Astelehena_Asteartea_Asteazkena_Osteguna_Ostirala_larunbata".split("_"),
    weekdaysShort: "Dom._Lun._Mar._Mier._Jue._Vier._Sab.".split("_"),
    weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_"),
});

moment.locale("es", {
    months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
    monthsShort: "Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.".split("_"),
    weekdays: "Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado".split("_"),
    weekdaysShort: "Dom._Lun._Mar._Mier._Jue._Vier._Sab.".split("_"),
    weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_"),
});

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        detection: options,
        fallbackLng: "en",
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
